import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/common/States";
import { fmtINR } from "@/lib/format";

export const money = (v) => fmtINR(Number(v || 0));
export const label = (s) => String(s || "").replace(/_/g, " ");

const STATUS_TONE = {
  draft: "neutral", pending_approval: "pending", approved: "invited", in_progress: "gold", completed: "invited",
  delivery_pending: "pending", delivery_approved: "active", delivered: "active", cancelled: "inactive",
  pending: "pending", rejected: "suspended", superseded: "inactive",
};
export const StatusBadge = ({ s, testId }) => <Badge tone={STATUS_TONE[s] || "neutral"} data-testid={testId}>{label(s)}</Badge>;

const DUE = { overdue: ["suspended", "Overdue"], upcoming: ["pending", "Due soon"], scheduled: ["active", "Scheduled"], none: ["neutral", "Not scheduled"] };
export const DueBadge = ({ s, testId }) => <Badge tone={DUE[s]?.[0]} data-testid={testId}>{DUE[s]?.[1] || "—"}</Badge>;

export const SERVICE_TYPES = ["periodic", "repair", "breakdown", "battery", "tyres", "accident", "inspection", "other"];

export const Pick = ({ value, onChange, options, placeholder, testId, className = "sm:w-48", allLabel }) => (
  <Select value={value || (allLabel ? "__all" : undefined)} onValueChange={(v) => onChange(v === "__all" ? "" : v)}>
    <SelectTrigger className={`bg-white ${className}`} data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      {allLabel && <SelectItem value="__all">{allLabel}</SelectItem>}
      {options.map((o) => <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const Pager = ({ page, total, limit, onPage, testId = "pager" }) => {
  const pages = Math.max(1, Math.ceil((total || 0) / limit));
  return (
    <div className="flex items-center justify-between px-4 py-3 border-t text-xs text-muted-foreground" data-testid={testId}>
      <span>{total || 0} records · page {page} of {pages}</span>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid={`${testId}-prev`}>Previous</Button>
        <Button size="sm" variant="outline" disabled={page >= pages} onClick={() => onPage(page + 1)} data-testid={`${testId}-next`}>Next</Button>
      </div>
    </div>
  );
};

export const Stat = ({ label: l, value, tone, testId }) => (
  <div className="g39-card p-4" data-testid={testId}>
    <div className="text-[12px] text-muted-foreground">{l}</div>
    <div className={`font-display text-xl sm:text-2xl font-bold mt-1 ${tone || ""}`} data-testid={`${testId}-value`}>{value}</div>
  </div>
);

export const Table = ({ cols, rows, testId, onRow }) => (
  <div className="overflow-x-auto">
    <table className="w-full text-sm" data-testid={testId}>
      <thead><tr className="text-left g39-label border-b">{cols.map((c) => <th key={c[0]} className={`py-2.5 px-3 whitespace-nowrap ${c[2] || ""}`}>{c[0]}</th>)}</tr></thead>
      <tbody>{rows.map((r) => (
        <tr key={r.id} className={`border-b last:border-0 hover:bg-secondary/40 ${onRow ? "cursor-pointer" : ""}`} onClick={onRow ? () => onRow(r) : undefined} data-testid={`${testId}-row-${r.id}`}>
          {cols.map((c) => <td key={c[0]} className={`py-2.5 px-3 ${c[2] || ""}`}>{c[1](r)}</td>)}
        </tr>
      ))}</tbody>
    </table>
  </div>
);
